/** Fichier refusé avant l'envoi : le message dit pourquoi. */
export class ImportRefusedError extends Error {
  name = "ImportRefusedError"
}
